

















































































import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})

export default class Credentials extends Vue {
  valid = false
  rules = [(v: string) => !!v || 'This field is required']  
  
  author = ""
  version =""
  uuid=""
  deckname=""
  description=""


  public test (){
    console.log("hi")
  }


  public getAuthor(){
    if(this.valid){
      return this.author 
    }
    else{return null}
  }

  public getVersion(){
    if(this.valid){
      return this.version
    }
      else{return null}
  }

  public getUUID(){ 
    if(this.valid){
      return this.uuid
  }else{
    return null}
  }

  public getDeckname(){
    if(this.valid){
      return this.deckname
    }else{
      return null
    }
  }

  public getDescription(){
    if(this.valid){
      return this.description
    }else{
      return null
    }
  }




}

